import React from 'react';
import { jsPDF } from 'jspdf';
import { useQuery } from 'react-query';
import {
    findMemberByPfNumber
} from "../../../api/apiServices";

const PdfServices = ({ member }) => {
    const pfNumber = member.pfNumber

    const {
        data: statement
    } = useQuery(['statement', pfNumber], () => findMemberByPfNumber(pfNumber));

    const memberInfo = statement?.member
    const payments = statement?.payments
    const ledger = statement?.ledger

    let totalPayments = 0;
    
        payments?.map(paymt => {
            totalPayments += paymt.payment_amount
            return totalPayments
        })
    
    
    const handleDownload = () => {
                
        let doc = new jsPDF();

        // var paymtFoot = paymentFooter(totalPayments)
        var totalPagesExp = '{total_pages_count_string}'
        var img = new Image();
        img.src = '/images/logos/proforum_main.jpg';
        // const dateFormat = "dd-MM-yyyy";
        let curr = new Date();
        curr.setDate(curr.getDate());
        let currentDate = curr.toISOString().substring(0, 10);
        doc.setTextColor('black');
        doc.setFontSize('7');
        doc.text(150, 12, "DATE PRINTED :");
        doc.text(170, 12, currentDate);
        doc.addImage(img, 'JPEG', 90, 15, 25, 25);
        doc.addFont('helvetica', '');
        doc.setTextColor('brown');
        doc.setFontSize('14');
        doc.setFont('', '', 'bold');
        doc.text(65, 50, "NDC PROFESSIONALS FORUM");

        doc.setTextColor('green');
        doc.setFontSize('12');
        doc.text(80, 55, "MEMBER STATEMENT");

        doc.setTextColor('brown');
        doc.setFontSize('12');
        doc.text(15, 70, 'MEMBER INFORMATION');

        // PERSONAL INFO
        doc.autoTable({
            html: "#memInfo",
            didDrawPage: function (data) {
                // Footer
                var str = 'Page ' + doc.internal.getNumberOfPages()
                // Total page number plugin only available in jspdf v1.0+
                if (typeof doc.putTotalPages === 'function') {
                    str = str + ' of ' + totalPagesExp
                }
                doc.setFontSize(8)

                // jsPDF 1.4+ uses getHeight, <1.4 uses .height
                var pageSize = doc.internal.pageSize
                var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
                doc.text(str, data.settings.margin.left, pageHeight - 10)
            },
            // margin: { top: 30 },
            startY: 75,
            theme: 'plain',
            footStyles: {
                fillColor: [0, 128, 0],
                textColor: [255, 255, 255],
                fontSize: 9,
                halign: 'right',
 
                columnStyles: {
                    0: {
                        halign: 'left',
                        tableWidth: 100,
                    },
                }
            },
            columnStyles: {
                0: {
                    halign: 'left',
                    tableWidth: 100,
                },
                1: {
                    halign: 'left',
                    tableWidth: 100,
                },
                2: { halign: 'left' },
                3: { halign: 'left' },
                4: { halign: 'left' },
                5: {
                    halign: 'right',
                    tableWidth: 100,
                },
            },
            headStyles: {
                fillColor: [0, 128, 0],
                fontSize: 9,
            },
            styles: {
                cellPadding: 1.5,
                fontSize: 8,
            },
        })

        // PAYMENT TABLE
        doc.text(15, doc.lastAutoTable.finalY + 10, 'PAYMENT TRANSITIONS');
        doc.autoTable({
            html: "#memPaymt",
            didDrawPage: function (data) {
                // Footer
                var str = 'Page ' + doc.internal.getNumberOfPages()
                // Total page number plugin only available in jspdf v1.0+
                if (typeof doc.putTotalPages === 'function') {
                    str = str + ' of ' + totalPagesExp
                }
                doc.setFontSize(8)

                // jsPDF 1.4+ uses getHeight, <1.4 uses .height
                var pageSize = doc.internal.pageSize
                var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
                doc.text(str, data.settings.margin.left, pageHeight - 10)
            },
            margin: { top: 30 },
            startY: doc.lastAutoTable.finalY + 14,
            theme: 'grid',
            footStyles: {
                fillColor: [0, 128, 0],
                textColor: [255, 255, 255],
                fontSize: 9,
                halign: 'right',
                columnStyles: {
                    0: {
                        halign: 'left',
                        tableWidth: 100,
                    },
                }
            },
            columnStyles: {
                0: {
                    halign: 'center',
                    tableWidth: 100,
                },
                1: {
                    halign: 'center',
                    tableWidth: 100,
                },
                2: { halign: 'left' },
                3: { halign: 'left' },
                4: { halign: 'left' },
                5: {
                    halign: 'right',
                    tableWidth: 100,
                },
            },
            headStyles: {
                fillColor: [0, 128, 0],
                fontSize: 9,
            },
            styles: {
                cellPadding: 1.5,
                fontSize: 8,
            },
        })


        // LEDGER TABLE
        doc.text(15, doc.lastAutoTable.finalY + 10, 'LEDGER ACCOUNT');
        doc.autoTable({
            html: "#memLedger",
            didDrawPage: function (data) {
                // Footer
                var str = 'Page ' + doc.internal.getNumberOfPages()
                // Total page number plugin only available in jspdf v1.0+
                if (typeof doc.putTotalPages === 'function') {
                    str = str + ' of ' + totalPagesExp
                }
                doc.setFontSize(8)

                // jsPDF 1.4+ uses getHeight, <1.4 uses .height
                var pageSize = doc.internal.pageSize
                var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
                doc.text(str, data.settings.margin.left, pageHeight - 10)
            },
            margin: { top: 30 },
            // startY: 165,
            startY: doc.lastAutoTable.finalY + 14,
            theme: 'grid',
            styles: {
                cellPadding: 1.5,
                fontSize: 8,
                halign: 'right',
            },
            columnStyles: {
                0: {
                    halign: 'center',
                    tableWidth: 100,
                },
                1: {
                    halign: 'right',
                    tableWidth: 100,
                },
                2: {
                    halign: 'right',
                    tableWidth: 100,
                },
                3: {
                    halign: 'right',
                    tableWidth: 100,
                },
                4: {
                    halign: 'right',
                    tableWidth: 100,
                },
            },
            headStyles: {
                fillColor: [0, 128, 0],
                fontSize: 9,
            },
        })


        // Total page number plugin only available in jspdf v1.0+
        if (typeof doc.putTotalPages === 'function') {
            doc.putTotalPages(totalPagesExp)
        }
        doc.setTextColor('black');
        doc.setFontSize('10');
        doc.setFont('', '', '');
        var pageSize = doc.internal.pageSize
        var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()
        var text = doc.splitTextToSize("NOTE: This statement shows member payment transactions from the date member joined NDC Professionals Forum. For further information, contact PROFORUM National Office", pageWidth - 35, {})

        doc.text(text,
            15, doc.lastAutoTable.finalY + 10
        )
        const date = Date().split(" ");
        const dateStr = date[0] + date[1] + date[2] + date[3] + date[4];
        doc.save(`${dateStr}.pdf`);
    };

    const imgLogo = (
        <>
            <div className="stmt-report">
                <div className="stmt-image">
                    <img src="/images/logos/proforum_main.jpg" alt="" className="logo" />
                    <h3>NDC PROFESSIONAL FORUM</h3>
                </div>
                <div className="stmt-title">
                    Member Summary Statement
                </div>
            </div>
        </>
    )

    const memInfo = (
        <>
            <div className="panel panel-default panel-br-4">
                <div className="panel-heading">
                    <div className="row">
                        <div className="col-sm-12">
                            <h4 className="panel-title">
                                <strong>MEMBER PERSONAL INFORMATION</strong>
                            </h4>
                        </div>
                    </div>
                </div>
                <div className="panel-body">
                    <div className="table-responsive lg">
                        <table className="table table-borderless" id="memInfo">
                            <tbody>
                                <tr>
                                    <td style={{ textTransform: "uppercase", fontSize: "14px", fontWeight: "500", color: "#000b41", textAlign: "left", whiteSpace: "nowrap" }}>FULL NAME</td>
                                    <td style={{ textTransform: "uppercase", fontSize: "14px", fontWeight: "500", color: "#000b41", textAlign: "justify", whiteSpace: "nowrap" }}>&nbsp;&nbsp;&nbsp;&nbsp;{memberInfo?.title} {memberInfo?.first_name} {memberInfo?.middle_name} {memberInfo?.last_name}</td>
                                    <td style={{ textTransform: "uppercase", fontSize: "14px", fontWeight: "500", color: "#000b41", align: "left", whiteSpace: "nowrap" }}>DATE JOINED</td>
                                    <td style={{ textTransform: "uppercase", fontSize: "14px", fontWeight: "500", color: "#000b41", align: "right", whiteSpace: "nowrap" }}>&nbsp;&nbsp;&nbsp;&nbsp;{memberInfo?.date_joined}</td>
                                </tr>
                                <tr>
                                    <td style={{ textTransform: "uppercase", fontSize: "14px", fontWeight: "500", color: "#000b41", textAlign: "left", whiteSpace: "nowrap" }}>PF NUMBER</td>
                                    <td style={{ textTransform: "uppercase", fontSize: "14px", fontWeight: "500", color: "#000b41", align: "right", whiteSpace: "nowrap" }}>&nbsp;&nbsp;&nbsp;&nbsp;{memberInfo?.pf_number}</td>
                                    <td style={{ textTransform: "uppercase", fontSize: "14px", fontWeight: "500", color: "#000b41", align: "left", whiteSpace: "nowrap" }}>VOTER ID NUMBER</td>
                                    <td style={{ textTransform: "uppercase", fontSize: "14px", fontWeight: "500", color: "#000b41", align: "right", whiteSpace: "nowrap" }}>&nbsp;&nbsp;&nbsp;&nbsp;{memberInfo?.voter_id_number}</td>
                                </tr>
                                <tr>
                                    <td style={{ textTransform: "uppercase", fontSize: "14px", fontWeight: "500", color: "#000b41", textAlign: "left", whiteSpace: "nowrap" }}>MOBILE NUMBER</td>
                                    <td style={{ textTransform: "uppercase", fontSize: "14px", fontWeight: "500", color: "#000b41", align: "right", whiteSpace: "nowrap" }}>&nbsp;&nbsp;&nbsp;&nbsp;{memberInfo?.mobile_number}</td>
                                    <td style={{ textTransform: "uppercase", fontSize: "14px", fontWeight: "500", color: "#000b41", align: "left", whiteSpace: "nowrap" }}>GENDER</td>
                                    <td style={{ textTransform: "uppercase", fontSize: "14px", fontWeight: "500", color: "#000b41", align: "right", whiteSpace: "nowrap" }}>&nbsp;&nbsp;&nbsp;&nbsp;{memberInfo?.gender}</td>
                                </tr>
                                <tr>
                                    <td style={{ textTransform: "uppercase", fontSize: "14px", fontWeight: "500", color: "#000b41", textAlign: "left", whiteSpace: "nowrap" }}>EMAIL ADDRESS</td>
                                    <td style={{ fontSize: "14px", fontWeight: "500", color: "#000b41", align: "right", whiteSpace: "nowrap" }}>&nbsp;&nbsp;&nbsp;&nbsp;{memberInfo?.email}</td>
                                    <td style={{ textTransform: "uppercase", fontSize: "14px", fontWeight: "500", color: "#000b41", align: "left", whiteSpace: "nowrap" }}>PROFESSION</td>
                                    <td style={{ textTransform: "uppercase", fontSize: "14px", fontWeight: "500", color: "#000b41", align: "right", whiteSpace: "nowrap" }}>&nbsp;&nbsp;&nbsp;&nbsp;{memberInfo?.profession}</td>
                                </tr>
                                <tr>
                                    <td style={{ textTransform: "uppercase", fontSize: "14px", fontWeight: "500", color: "#000b41", textAlign: "left", whiteSpace: "nowrap" }}>REGION</td>
                                    <td style={{ fontSize: "14px", fontWeight: "500", color: "#000b41", align: "right", whiteSpace: "nowrap" }}>&nbsp;&nbsp;&nbsp;&nbsp;{memberInfo?.region}</td>
                                    <td style={{ textTransform: "uppercase", fontSize: "14px", fontWeight: "500", color: "#000b41", align: "left", whiteSpace: "nowrap" }}>CONSTITUENCY</td>
                                    <td style={{ textTransform: "uppercase", fontSize: "14px", fontWeight: "500", color: "#000b41", align: "right", whiteSpace: "nowrap" }}>&nbsp;&nbsp;&nbsp;&nbsp;{memberInfo?.constituency}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    )
    const memPaymt = (
        <>
            <div className="panel panel-default panel-br-4">
                <div className="panel-heading">
                    <div className="row">
                        <div className="col-sm-12">
                            <h4 className="panel-title">
                                <strong>MEMBER PAYMENT TRANSACTIONS</strong>
                            </h4>
                        </div>
                    </div>
                </div>
                <div className="panel-body">
                    <div className="table-responsive lg">
                        <table className='table table-borderless table-hover table-striped' id="memPaymt">
                            <thead>
                                <tr>
                                    <th style={{ textAlign: "center" }}>Year</th>
                                    <th style={{ textAlign: "center" }}>Payment Date</th>
                                    <th style={{}}>Receipt Number</th>
                                    <th style={{}}>Payment Type</th>
                                    <th style={{ whiteSpace: "nowrap" }}>Description</th>
                                    <th style={{ textAlign: "right" }}>Amount (GHS)</th>
                                </tr>
                            </thead>
                            <tbody>
                                {payments?.map(payment => (
                                    <tr key={payment.id}>
                                        <td style={{ textAlign: "center" }}>{payment.year}</td>
                                        <td style={{ textAlign: "center" }}>{payment.payment_date}</td>
                                        <td style={{ textAlign: "left" }}>{payment.receipt_number}</td>
                                        <td style={{ textTransform: "uppercase" }}>{payment.payment_type}</td>
                                        <td style={{ whiteSpace: "nowrap" }}>{payment.description}</td>
                                        <td style={{ textAlign: "right" }}>{payment.payment_amount.toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
                                    </tr>
                                ))}
                                <tr>
                                    <td colSpan="5" style={{fontWeight: "900"}}>
                                        TOTAL PAYMENT
                                    </td>
                                    {totalPayments < 0 ? (
                                        <td className="border-bottom" style={{ width: "40%", textAlign: "right", fontSize: "16px", fontWeight: "700", color: "darkred" }}>
                                            ({(totalPayments * -1).toLocaleString(undefined, { minimumFractionDigits: 2 })}) </td>
                                    ) : (
                                        <td className="border-bottom" style={{ width: "40%", textAlign: "right", fontSize: "16px", fontWeight: "700", color: "darkred" }}>
                                                {totalPayments.toLocaleString(undefined, { minimumFractionDigits: 2 })} </td>
                                    )}
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    )
    const memLedger = (
        <>
            <div className="panel panel-default panel-br-4">
                <div className="panel-heading">
                    <div className="row">
                        <div className="col-sm-12">
                            <h4 className="panel-title">
                                <strong>MEMBER LEDGER ACCOUNT (Mandatory Payments)</strong>
                            </h4>
                        </div>
                    </div>
                </div>
                <div className="panel-body">

                    <div className="table-responsive lg">
                        <table className="table table-borderless" id="memLedger">
                            <thead>
                                <tr>
                                    <th style={{ textAlign: 'center' }}>YEAR</th>
                                    <th style={{ textAlign: 'right' }}>OPENING BALANCE </th>
                                    <th style={{ textAlign: 'right' }}>EXPECTED PAYMENT</th>
                                    <th style={{ textAlign: 'right' }}>AMOUNT PAID</th>
                                    <th style={{ textAlign: 'right' }}>CLOSING BALANCE</th>
                                </tr>
                            </thead>
                            <tbody>
                                {ledger?.map(ledger => <tr key={ledger.id} style={{ cursor: "pointer" }}>
                                    <td style={{ fontSize: "16px", fontWeight: "500", color: "#000b41" }} className="text-center">{ledger.year}</td>
                                    <td style={{ fontSize: "16px", fontWeight: "500", color: "#000b41" }} className="text-right">{ledger.opening_balance.toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
                                    {ledger.expected_total_amount < 0 ? (
                                        <td style={{ fontSize: "16px", fontWeight: "500", color: "#000b41" }} className="text-right">({(ledger.expected_total_amount * -1).toLocaleString(undefined, { minimumFractionDigits: 2 })}) </td>
                                    ) : (
                                        <td style={{ fontSize: "16px", fontWeight: "500", color: "#000b41" }} className="text-right">{ledger.expected_total_amount.toLocaleString(undefined, { minimumFractionDigits: 2 })} </td>
                                    )}
                                    <td style={{ fontSize: "16px", fontWeight: "500", color: "#000b41" }} className="text-right">{ledger.total_amount_paid.toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
                                    {ledger.closing_balance < 0 ? (
                                        <td style={{ fontSize: "16px", fontWeight: "500", color: "#000b41" }} className="text-right">({(ledger.closing_balance * -1).toLocaleString(undefined, { minimumFractionDigits: 2 })})</td>
                                    ) : (
                                        <td style={{ fontSize: "16px", fontWeight: "500", color: "#000b41" }} className="text-right">{ledger.closing_balance.toLocaleString(undefined, { minimumFractionDigits: 2 })}</td>
                                    )}
                                </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    )

    return (
        <>
            <section className="content-header">
                <h1>Member Statement</h1>
            </section>
            <section className="content">
                <div className="box">
                    <div className="box-body">
                        <div className="panel panel-default panel-br-4">
                            <div className="panel-heading">
                                <div className="row">
                                    <div className="col-sm-12">
                                        <h4 className="panel-title">
                                            <span>
                                                <button
                                                    className="btn btn-success"
                                                    onClick={handleDownload}
                                                >
                                                    Download PDF
                                                </button>
                                            </span>
                                        </h4>
                                    </div>
                                </div>
                            </div>
                            <div id="pdfRef1" className="panel-body">
                                {imgLogo}
                                {memInfo}
                                {memPaymt}
                                {memLedger}
                            </div>
                            <div className="panel-footer">
                            </div>
                        </div>
                        <div className="box-footer"></div>
                    </div>
                </div>
            </section>
        </>
    );

}

export default PdfServices

// function paymentFooter(totPayments) {
        
//     return [
//         {
//             year: {
//                 content: 'Total Payment Transactions',
//                 colSpan: 5,
//                 styles: { halign: 'left' },
//             },
//             payment_amount: totPayments.toLocaleString(undefined, { minimumFractionDigits: 2 })
//         },
//     ]
// }
